module.exports = __webpack_public_path__ + "static/media/6TunasDouro3.6f6f0c5c.jpg";